// Exact copy from your client
export function scrollToBottom(elementRef) {
  if (!elementRef || !elementRef.current) return;
  const el = elementRef.current;
  el.scrollTop = el.scrollHeight;
}

export function isNearBottom(elementRef, threshold = 80) {
  const el = elementRef.current;
  if (!el) return true;
  const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
  return distance < threshold;
}

export function createResizeHandler(currentWidth, setWidth, minWidth, maxWidth) {
  return (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = currentWidth;

    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientX - startX;
      let width = startWidth + delta;
      if (width < minWidth) width = minWidth;
      if (width > maxWidth) width = maxWidth;
      setWidth(width);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };
}

export function generateId() {
  return crypto.randomUUID ? crypto.randomUUID() : String(Date.now());
}
